(function (doc, win) {
  var docEl = doc.documentElement
  var resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'
  var recalc = function () {
    var clientWidth = docEl.clientWidth
    console.log(clientWidth)
    if (!clientWidth) return
    docEl.style.fontSize = Math.floor(100 * (clientWidth / 1920)) + 'px'
    console.log(docEl.style.fontSize)
  }
  if (!doc.addEventListener) return
  win.addEventListener(resizeEvt, recalc, false)
  doc.addEventListener('DOMContentLoaded', recalc, false)
})(document, window)



// WEBPACK FOOTER //
// ./src/utils/flexible/index.js